import { Pipe as ConnPipe, Pipe, PipeTransform } from '@angular/core';
import NiboWhatsAppConnection from './models/nibo-whatsapp-connection';
import { ConnectionStatusFilterConfig } from './components/connections-list/connections-list.component';

@Pipe({
  standalone: false,
  name: 'status',
  pure: false
})
export class StatusPipe implements PipeTransform {

  transform(value: NiboWhatsAppConnection[], arg: ConnectionStatusFilterConfig[]): NiboWhatsAppConnection[] {
    const filter = arg.filter(a => a.checked);
    return value.filter(conn => {
      if (!conn.connection?.whatsAppStatus)
        return true;
      return filter.some(a => a.value === conn.connection?.whatsAppStatus);
    })
  }
}
